import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/noData_empty.svg'


const _hoisted_1 = {
  key: 1,
  class: "flex flex-row w-full"
}
const _hoisted_2 = {
  id: "dashboard-container",
  class: `w-full pr-4 md:pr-8`
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "space-y-6 mb-10" }
const _hoisted_5 = {
  key: 1,
  class: "bg-white justify-center items-center flex flex-col mx-auto text-12px xxl:text-14px overflow-hidden h-screen"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-48 xxl:w-64 mt-8 mx-auto",
  alt: "no-data"
}, null, -1)
const _hoisted_7 = { class: "text-gray-lp-300 py-2" }
const _hoisted_8 = {
  key: 2,
  id: "dashboard-content",
  class: "h-screen flex flex-col"
}
const _hoisted_9 = {
  id: "dashboard-title-container",
  class: "grid grid-cols-2 gap-2"
}
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-end text-gray-lp-800 text-10px md:text-12px font-normal italic"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 0,
  class: "text-gray-lp-600 text-12px md:text:14px mt-3"
}
const _hoisted_14 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_15 = { class: "grid grid-cols-1 gap-6 hidden" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-normal text-12px xxl:text-14px text-gray-lp-600" }, " Maaf, terjadi kesalahan pada sistem Genesis yang menyebabkan terdapat selisih ongkir untuk STT luar pulau Jawa dengan berat dibawah 0,5 kg. Biaya akan dikembalikan ke saldo akun dalam 24 jam. Berat 0,5 kg ditutup sementara untuk mencegah kendala. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ShortcutBooking = _resolveComponent("ShortcutBooking")!
  const _component_DashboardPos = _resolveComponent("DashboardPos")!
  const _component_DashboardConsole = _resolveComponent("DashboardConsole")!
  const _component_DashboardClient = _resolveComponent("DashboardClient")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isError && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.getDashboardDelivery
        }, null, 8, ["errorType", "onTryAgain"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_skeleton, {
                      width: "30%",
                      height: "1.8rem"
                    }),
                    _createVNode(_component_skeleton, {
                      width: "65%",
                      height: "1.4rem"
                    })
                  ]),
                  _createVNode("div", {
                    class: `grid grid-cols-${_ctx.columnCount} gap-6`
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(Array(6), (_, index) => {
                      return (_openBlock(), _createBlock(_component_Card, {
                        key: index,
                        isLoading: _ctx.isLoading
                      }, null, 8, ["isLoading"]))
                    }), 128))
                  ], 2)
                ]))
              : (_ctx.isEmpty)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.emptyState")), 1)
                  ]))
                : (!_ctx.isEmpty)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _createVNode(_component_Title, {
                          label: _ctx.$t('dashboard.greeting', { name: _ctx.profileData.name }),
                          bold: "bold",
                          fontSize: 20
                        }, null, 8, ["label"]),
                        (!!_ctx.activeMenuTab.match(/^current-stt$|^cod-dashboard$/))
                          ? (_openBlock(), _createBlock("div", _hoisted_10, [
                              _createVNode(_component_Icons, {
                                name: "refresh",
                                class: "w-5 text-red-lp-300 mr-2"
                              }),
                              (!!_ctx.activeMenuTab.match(/^current-stt$/))
                                ? (_openBlock(), _createBlock("span", _hoisted_11, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("dashboard.sttNoteBefore")) + " ", 1),
                                    _createVNode("strong", null, _toDisplayString(_ctx.$t("dashboard.sttNoteStrong")), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("dashboard.sttNoteAfter")), 1)
                                  ]))
                                : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("dashboard.lastSync")) + " " + _toDisplayString(_ctx.lastSycnCODDashboard), 1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.activeMenuTab === 'cod-dashboard')
                        ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.codIntro")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isShortcutEnable)
                        ? (_openBlock(), _createBlock("div", _hoisted_14, [
                            _createVNode(_component_ShortcutBooking)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.accountTypeDetail === 'pos')
                        ? (_openBlock(), _createBlock(_component_DashboardPos, { key: 2 }))
                        : _createCommentVNode("", true),
                      (_ctx.accountTypeDetail === 'console')
                        ? (_openBlock(), _createBlock(_component_DashboardConsole, { key: 3 }))
                        : _createCommentVNode("", true),
                      (_ctx.isDashboardCorporate)
                        ? (_openBlock(), _createBlock(_component_DashboardClient, { key: 4 }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", _hoisted_15, [
              _createVNode(_component_Card, {
                title: "Informasi Penting",
                iconLeft: "",
                customClass: "items-start"
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createVNode("div", {
                    class: "font-medium text-16px text-red-lp-100 cursor-pointer pt-2",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSeeMore && _ctx.onSeeMore(...args)))
                  }, _toDisplayString(_ctx.$t("dashboard.seeMore")), 1)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, _ctx.role === 'console' || _ctx.role === 'sub-console']
            ])
          ])
        ])),
    (_ctx.accountTypeDetail === 'console' && _ctx.activeMenuTab !== 'cod-dashboard')
      ? (_openBlock(), _createBlock(_component_WidgetDownload, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}